// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__25-X4","legal":"Footer_legal__5hDy7"};